<template>
  <div class="LoadingComponent">
    <custom-loading-component
      :active.sync="isLoadingFromAPI"
      :can-cancel="false"
      :is-full-page="true"
      color="#33304c">
    </custom-loading-component>
  </div>
</template>

<script>
export default {
  name: 'LoadingComponent',
  computed : {
    isLoadingFromAPI: {
      get () {
        return this.$store.state.isAPILoading
      }
    },
  }
}
</script>
